import React, { useState } from 'react';

import useAction from 'hooks/use-action';
import { useMutation } from 'react-query';
import { CartDeleteItemService } from 'services/payments';

import UseModal from 'hooks/use-modal';
import Modal from '@core/components/Modal/Modal';

import ContentPrice from 'components/common/contentprice/ContentPrice';
import ActionButton from '@core/components/actionbutton/ActionButton';

import { CART_REFETCH_ACTION } from 'constants/Actions';

import RecycleBinIcon from 'assets/icons/recyclebin-icon.svg';
import ClockIcon from 'assets/icons/clock-icon.svg';

import classes from './CartItem.module.scss';

const CartItem = ({
	item: {
		image,
		item_id,
		price,
		title,
		type: apiType,
		payable_price,
		promotion_percentage,
		description,
		warning_message,
		currency
	},
	refetchCart,
	toast
}) => {
	const [type] = useState(() => {
		if (apiType === 'course') {
			return 'Job qualification';
		} else if (apiType === 'lecture') {
			return 'Course';
		}
		return apiType;
	});
	const [actionHandler] = useAction({ type: CART_REFETCH_ACTION });
	const { show, showModal, destroyModal } = UseModal();
	const { mutate: deleteCoursefn, isLoading } = useMutation(CartDeleteItemService, {
		onSuccess: (data) => {
			toast(data.data.message, 'success');
			refetchCart();
			actionHandler();
		}
	});
	return (
		<>
			<div className={`${classes['cart-item-wrapper']} `}>
				<div className="w-100 d-flex flex-row align-items-center justify-content-between">
					<div className="d-flex flex-row">
						<img src={image} alt={title} />
						<div className="d-flex flex-column align-items-start mx-2">
							<p>{type}</p>
							<h5>{title}</h5>
							<ContentPrice
								price={price}
								payable_price={payable_price}
								promotion_percentage={promotion_percentage}
								currency={currency}
							/>
						</div>
					</div>
					<button onClick={showModal} data-testid="delete-item-button">
						<RecycleBinIcon />
					</button>
				</div>
				{description && (
					<p className={`${classes['cart-item-wrapper__desc']} mt-3 mb-0`}>{description}</p>
				)}
				{warning_message && (
					<p
						className={`${classes['cart-item-wrapper__warning-message']} d-flex flex-row align-items-center gap-2 mt-3 mb-0`}>
						<ClockIcon /> {warning_message}
					</p>
				)}
			</div>

			<Modal closeHandler={destroyModal} show={show}>
				<div className={`${classes['remove-item-modal']} d-flex flex-column`}>
					<h4>Remove Item?</h4>
					<p>Are you sure you want to remove {title} from your cart?</p>
					<div className="d-flex flex-row align-items-center justify-content-end">
						<button className="btn" onClick={destroyModal}>
							Cancel
						</button>
						<ActionButton onClick={() => deleteCoursefn(item_id)} kind="blank" loading={isLoading}>
							Remove
						</ActionButton>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default CartItem;
